import { render, staticRenderFns } from "./AddEditSubEvent.vue?vue&type=template&id=2081c27f"
import script from "./AddEditSubEvent.vue?vue&type=script&lang=js"
export * from "./AddEditSubEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports